import dayjs from '@/plugins/dayjs';
import { TYPE_FORMAT_TIME } from '@/constants/AnswerOrQuestionConstant';
import { DEFAULT_DATE_FORMAT, DB_DATE_TIME_FORMAT, DEFAULT_DATE_TIME_FORMAT } from '@/constants/common';
import {
  STATUS_WON_SELLER, STATUS_WON_BIDDER, STATUS_BIDDING_SELLER, STATUS_FORWARDER_WHEN_SELLER_BAN
} from '@/constants/dbConstant';

export function formatTime(startDate, endDate, masterData) {
  let message = '';
  if (startDate > endDate) {
    return message;
  }
  if (!startDate || !endDate) {
    return message;
  }
  let startYear = dayjs(startDate).format('YYYY');
  const startMonth = dayjs(startDate).format('MM');
  const startDay = dayjs(startDate).format('DD');
  let endYear = dayjs(endDate).format('YYYY');
  const endMonth = dayjs(endDate).format('MM');
  const endDay = dayjs(endDate).format('DD');
  const startRes = masterData.find((item => Number(item.year) === Number(startYear)));
  const endRes = masterData.find((item => Number(item.year) === Number(endYear)));

  if (startRes) {
    startYear = startRes.japanese_year;
  }
  if (endRes) {
    endYear = endRes.japanese_year;
  }

  const dateStartMessage = startYear + this.$i18n.t('message.date.year') + startMonth + this.$i18n.t('message.date.month')
      + startDay + this.$i18n.t('message.date.day');

  const dateEndMessage = endYear + this.$i18n.t('message.date.year') + endMonth + this.$i18n.t('message.date.month')
      + endDay + this.$i18n.t('message.date.day');

  message = dateStartMessage + this.$i18n.t('message.date.to') + dateEndMessage;

  return message;
}

export function formatTimeJapan(date, type) {
  let dateFormat = '';
  if (!date) {
    return dateFormat;
  }
  const year = dayjs(date).format('YYYY');
  const month = dayjs(date).format('MM');
  const day = dayjs(date).format('DD');
  const hour = dayjs(date).format('h');
  const minute = dayjs(date).format('m');

  if (type === TYPE_FORMAT_TIME[1]) {
    dateFormat = `${year}年${month}月${day}日`;
  } else {
    dateFormat = `${hour}時${minute}分`;
  }

  return dateFormat;
}

export function formatStatusRoom(userLoginId, sellerId, status, isForwarder) {
  if (Number(userLoginId) === Number(sellerId)) {
    return STATUS_WON_SELLER[status];
  }
  if (isForwarder && Number(status) === Number(STATUS_BIDDING_SELLER.WON_BIDDER_DELETE_SYSTEM)) {
    return STATUS_FORWARDER_WHEN_SELLER_BAN;
  }

  return STATUS_WON_BIDDER[status];
}

export function formatTimeNotMinute(value) {
  let time = null;
  if (value) {
    const timeString = new Date(`${value} UTC`);
    time = dayjs(timeString).format(DEFAULT_DATE_FORMAT);
  }

  return time;
}

export function formatTimeUTC(value) {
  let time = null;
  if (value) {
    const timeString = new Date(`${value} UTC`);
    time = dayjs(timeString).format(DB_DATE_TIME_FORMAT);
  }

  return time;
}

export function formatTimeHour(value) {
  let time = null;
  if (value) {
    const timeString = new Date(`${value} UTC`);
    time = dayjs(timeString).format(DEFAULT_DATE_TIME_FORMAT);
  }

  return time;
}

export function formatTimeUTCToLocal(value) {
  let time = null;
  if (value) {
    time = new Date(`${dayjs(value).format(DB_DATE_TIME_FORMAT)} UTC`);
  }

  return time;
}

export function formatMessage(text) {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  text = text.trim();
  text = text.replace(urlRegex, (url) => (
    `<a target="_blank" class="a-link" href="${url}">${url}</a>`
  ));

  return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
}
